import { render, staticRenderFns } from "./Co2Modal.html?vue&type=template&id=146a7aba&scoped=true&external"
import script from "./Co2Modal.js?vue&type=script&lang=js&external"
export * from "./Co2Modal.js?vue&type=script&lang=js&external"
import style0 from "./Co2Modal.scss?vue&type=style&index=0&id=146a7aba&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146a7aba",
  null
  
)

export default component.exports